import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Waste } from '@classes/waste/waste';


@Injectable({
  providedIn: 'root'
})
export class WasteService {

  waste: Waste[] = [
    {
      infraction_id: 1,
      camera: "caméra 1",
      video_stream: "http://IP/video1.mp4"
    },
    {
      infraction_id: 2,
      camera: "caméra 2",
      video_stream: "http://IP/video2.mp4"
    },
    {
      infraction_id: 3,
      camera: "caméra 3",
      video_stream: "http://IP/video3.mp4"
    },
    {
      infraction_id: 4,
      camera: "caméra 4",
      video_stream: "http://IP/video4.mp4"
    },
  ]
  constructor(

    private http: HttpClient

  ) { }

}